(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["manamu-pdp-250ml"] && !Shopify.designMode) return;
  try {
    
(function(){
  var mainImg = document.getElementById('pdp250MainImg');

  document.querySelectorAll('.pdp250-thumb').forEach(function(th){
    th.addEventListener('click', function(){
      if (th.dataset.src && mainImg) mainImg.src = th.dataset.src;

      document.querySelectorAll('.pdp250-thumb').forEach(function(t){
        t.classList.remove('is-active');
      });

      th.classList.add('is-active');
    });
  });

  var qtyInput = document.getElementById('pdp250Qty');

  document.querySelectorAll('.pdp250-qty-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      if (!qtyInput) return;

      var step = parseInt(btn.dataset.step, 10) || 0;
      var current = parseInt(qtyInput.value, 10) || 1;
      var min = parseInt(qtyInput.min, 10) || 1;
      var max = parseInt(qtyInput.max, 10) || 99;
      var next = current + step;

      if (next < min) next = min;
      if (next > max) next = max;

      qtyInput.value = next;
    });
  });

  var sticky = document.getElementById('pdp250Sticky');
  var stickyBtn = document.getElementById('pdp250StickyBtn');
  var heroSection = document.querySelector('.pdp250-hero');

  if (sticky && heroSection) {
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          sticky.classList.remove('is-visible');
          sticky.setAttribute('aria-hidden', 'true');
        } else {
          sticky.classList.add('is-visible');
          sticky.setAttribute('aria-hidden', 'false');
        }
      });
    }, { threshold: 0.1 });

    observer.observe(heroSection);
  }

  if (stickyBtn) {
    stickyBtn.addEventListener('click', function(){
      var form = document.getElementById('pdp250CartForm');

      if (form && typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else if (form) {
        form.submit();
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
